import { render, staticRenderFns } from "./SupporterView.vue?vue&type=template&id=3822191a&scoped=true&"
import script from "./SupporterView.vue?vue&type=script&lang=js&"
export * from "./SupporterView.vue?vue&type=script&lang=js&"
import style0 from "./SupporterView.vue?vue&type=style&index=0&id=3822191a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3822191a",
  null
  
)

export default component.exports